import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';


// required for AOT compilation
export function createHttpTranslate(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http,'./i18n/','.json');
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // ngx-translate and the loader module
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: createHttpTranslate,
            deps: [HttpClient]
        }
    })
   
  ],
  exports: [
    TranslateModule
  ],
  providers:[
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class LangTranslationModule { }
